<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cámaras"
        [filterDelay]="0"
        [loading]="cameraService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true" 
        [value]="cameraService.cameras"
        pDroppable="row">
        
        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Cámaras registradas
              </div>
              <div class="col-8 text-end">
                <button 
                  (click)="open()" 
                  class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>
                <button 
                  (click)="cameraService.getAll(neighborhoodId!)" 
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="cameraId">
              ID
              <p-sortIcon field="cameraId"></p-sortIcon>
              <p-columnFilter type="text" field="cameraId" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="description">
              Descripción
              <p-sortIcon field="description"></p-sortIcon>
              <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="hostIp">
              Host
              <p-sortIcon field="hostIp"></p-sortIcon>
              <p-columnFilter type="text" field="hostIp" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="ip">
              IP
              <p-sortIcon field="ip"></p-sortIcon>
              <p-columnFilter type="text" field="ip" display="menu"></p-columnFilter>
            </th>

            <th>Caseta</th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-camera>
          <tr class="p-selectable-row">

            <td>
              <span class="p-column-title">ID</span>
              {{ camera.cameraId }}
            </td>

            <td>
              <span class="p-column-title">Descripción</span>
              {{ camera.description }}
            </td>

            <td>
              <span class="p-column-title">Host</span>
              {{ camera.hostIp }}:{{ camera.hostPort }}
            </td>

            <td>
              <span class="p-column-title">IP Camera</span>
              {{ camera.ip }}
            </td>

            <td>
              <span class="p-column-title">Caseta</span>
              @if (camera.gate) {
                <span class="badge text-bg-primary">
                  {{ camera.gate.gateName }}
                </span>
              } @else {
                <span class="text-muted">—</span>
              }
            </td>

            <td>
              <button
                (click)="open(camera)"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">more_vert</i>
              </button>
              <button 
                (click)="screenshot(camera)"
                ngbTooltip="Tomar captura"
                placement="top"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">camera_alt</i>
              </button>
              <button 
                (click)="watchCamera(camera)"
                ngbTooltip="Ver cámara"
                placement="top"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">videocam</i>
              </button>
              <button 
                (click)="delete(camera)" 
                class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
              <td 
                colspan="4"
                class="text-center">
                Sin registros
              </td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>
</div>
